// extracted by mini-css-extract-plugin
export default {"modal":"components-settings-activity-modal-mapping-changes-module__modal"};